import * as React from 'react';
import { Box, Button, Typography } from '@mui/material';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { Link } from 'react-router-dom';

export function AppNotInstalledPage({ appId }: { appId?: string }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 360,
                p: 4,
                textAlign: 'center',
            }}
        >
            <BlockOutlinedIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
            <Typography variant="h5" fontWeight={700} gutterBottom>
                App Not Installed
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 420 }}>
                {appId
                    ? `The "${appId}" module is not enabled for your account.`
                    : 'This module is not enabled for your account.'}
                {' '}Contact your administrator to enable access.
            </Typography>
            <Button component={Link} to="/" variant="contained">
                Go to Home
            </Button>
        </Box>
    );
}
